import React, { createContext, useContext, useState, useEffect } from 'react';

interface NetworkContextType {
  isConnected: boolean | null;
}

const NetworkContext = createContext<NetworkContextType>({ isConnected: null });

export function NetworkProvider({ children }: { children: React.ReactNode }) {
  const [isConnected, setIsConnected] = useState<boolean | null>(null);

  useEffect(() => {
    setIsConnected(typeof navigator === 'undefined' ? true : navigator.onLine);
    const goOnline = () => setIsConnected(true);
    const goOffline = () => setIsConnected(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  return <NetworkContext.Provider value={{ isConnected }}>{children}</NetworkContext.Provider>;
}

export const useNetwork = () => useContext(NetworkContext);
